import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import { GET_CHAT_MESSAGES, GET_MESSAGE_PAGE } from "@/utils/api-url";

export default class Message extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"] || params["id"];
  }

  static resourceName() {
    return "message";
  }

  static getPage(params) {
    return apiDispatcher(GET_MESSAGE_PAGE(params.id, { ...params, id: null }));
  }

  static index(params) {
    return apiDispatcher(GET_CHAT_MESSAGES(params));
  }

  static LIMIT = 20;
}
